import React, { useEffect, useState, useRef } from "react";
import { Navigate, useLocation, useRoutes } from "react-router";
import { lazy } from "react";
import { useDispatch, useSelector } from "react-redux";
import MaxLayout from "../max-layout/MaxLayout";
import Login from "../pages/authentication/Login";
import Chat from "../pages/chat/Chat";
import DocumentUpload from "../pages/document-upload/DocumentUpload";
import Translate from "../pages/translate/Translate";
import History from "../pages/history/History";
import SignUp from "../pages/authentication/SignUp";
import ResetPassword from "../pages/authentication/ResetPassword";
import LoginAnimation from "../components/LoginAnimation";
import PrivateRoute from "../components/PrivateRoute";
import PublicRoute from "../components/PublicRoute";
import UserService from "../services/user";
import PaymentService from "../services/payment";
import { persistProfileToStorage, readStoredUserId } from "../hooks/useSidebarData";
import { setUser, setTokenStatus } from "../store/slices/userSlice";
import { toastError } from "../components/Toast";
import NotFound from "../pages/not-found/NotFound";

const SuspenseLoader = (Component) => (props) =>
  (
    <React.Suspense fallback={<withLoader />}>
      <Component {...props} />
    </React.Suspense>
  );

const Home = SuspenseLoader(lazy(() => import("../max-layout/MaxLayout")));
function RedirectionWrapper({ to }) {
  const queryString = window.location.search;
  if (queryString && (queryString.includes("success") || queryString.includes("fail"))) {
    return <Navigate to={`/plans${queryString}`} />;
  }
  if (queryString) {
    return <Navigate to={`${to}${queryString}`} />;
  }
  return <Navigate to={to} />;
}
const routes = (isLogin) => [
  {
    path: "/",
    element: <MaxLayout />,
    children: [
      {
        element: <RedirectionWrapper to="/chat" />,
        index: true,
      },
      {
        path: "/chat",
        element: (
          <PrivateRoute>
            <Chat />
          </PrivateRoute>
        ),
      },
      // {
      //   path: "/document-upload",
      //   element: (
      //     <PrivateRoute>
      //       <DocumentUpload />
      //     </PrivateRoute>
      //   ),
      // },
      {
        path: "/translate",
        element: (
          <PrivateRoute>
            <Translate />
          </PrivateRoute>
        ),
      },
      {
        path: "/transcribe",
        element: (
          <PrivateRoute>
            <Translate />
          </PrivateRoute>
        ),
      },
      {
        path: "/history",
        element: (
          <PrivateRoute>
            <History />
          </PrivateRoute>
        ),
      },
      {
        path: "*",
        element: <NotFound />,
      },
    ],
  },
  {
    path: "/login",
    element: (
      <PublicRoute>
        <Login />
      </PublicRoute>
    ),
  },
  {
    path: "/plans",
    element: <Login />,
  },
  {
    path: "/payment/success",
    element: <Navigate to={`/plans${window.location.search}`} />,
  },
  {
    path: "/payment/fail",
    element: <Navigate to="/plans?fail" />,
  },
  {
    path: "/sign-up",
    element: (
      <PublicRoute>
        <SignUp />
      </PublicRoute>
    ),
  },
  {
    path: "/reset-password",
    element: <ResetPassword />,
  },
  /* {
    path: "/animation",
    element: <LoginAnimation />,
  }, */
];

// export default function Router() {
//   return useRoutes(routes());
// }
export default function Routes(props) {
  const location = useLocation();
  const chat = useSelector((state) => state.chat);
  const reduxUser = useSelector((state) => state.user?.user);
  const dispatch = useDispatch();
  const hasFetchedProfile = useRef(false);
 
  const { isLogin } = props;
  const userId = readStoredUserId();

  const getUserDetails = async () => {
    try {
      const response = await UserService?.getProfile();
      if (response?.data?.data) {
        const data = response.data.data;
        dispatch(setUser(data));
        dispatch(setTokenStatus(data));
        persistProfileToStorage(data);
        window.dispatchEvent(new Event("profileUpdated"));
      } else if (userId) {
        const fallbackRes = await UserService?.getUserDetails(userId);
        if (fallbackRes?.data?.data) {
          const fData = fallbackRes.data.data;
          dispatch(setUser(fData));
          dispatch(setTokenStatus(fData));
          persistProfileToStorage(fData);
          if (fData?.note) {
            localStorage.setItem("linko_rejection_note", fData.note);
            localStorage.removeItem("linko_contact_sent");
          }
          window.dispatchEvent(new Event("profileUpdated"));
        }
      }

      try {
        const token = localStorage.getItem("linko_web");
        if (token) {
          const subRes = await PaymentService?.getActiveSubscription();
          const subs = subRes?.data?.data;
          if (subs?.length > 0) {
            localStorage.setItem("linko_active_sub", JSON.stringify(subs[0]));
            if (subs[0].subscription_id?.plan_name || subs[0].plan_name) {
              localStorage.setItem("plan_name", subs[0].subscription_id?.plan_name || subs[0].plan_name);
            }
            window.dispatchEvent(new Event("planUpdated"));
          }
        }
      } catch (_e) {}
    } catch (error) {
      console.error("getUserDetails error:", error);
    }
  };

  useEffect(() => {
    if (isLogin && !hasFetchedProfile.current) {
      hasFetchedProfile.current = true;
      getUserDetails();
    }
  }, [isLogin]);


  return useRoutes(routes(isLogin));
}
